import { render, staticRenderFns } from "./MoreProducts.vue?vue&type=template&id=847f3616&"
import script from "./MoreProducts.vue?vue&type=script&lang=js&"
export * from "./MoreProducts.vue?vue&type=script&lang=js&"
import style0 from "./MoreProducts.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/registry.npmjs.org/vue-loader/15.9.1_fa71e5e22e237a2e8403a424bafe49a7/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports